import type { PayloadMediaUpload } from "@portal/app/_server/services/formFunnel/payloadTypes";

export interface FormFunnelImageProps {
  src: string;
  alt: string;
  width?: number;
  height?: number;
}

/** Resolves a populated Payload media upload or a legacy URL string. */
export function getFormFunnelImageProps(
  image: PayloadMediaUpload | string | null | undefined,
  altOverride?: string
): FormFunnelImageProps | null {
  if (typeof image === "string") {
    return image ? { src: image, alt: altOverride ?? "" } : null;
  }

  if (!image?.url) return null;

  return {
    src: image.url,
    alt: altOverride ?? image.alt ?? "",
    width: image.width,
    height: image.height,
  };
}
